import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { required, number, positiveNumber } from '../../../forms';
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
  </InputGroup>
);

export const customPhoneInput = ({ input, label, type, country, meta: { touched, error, warning } }) => (
  <InputGroup>
  {label && <ControlLabel>{label}</ControlLabel>}
  <PhoneInput {...input} type={type} country={country} />
  { formatPhoneNumber(input.value) ? (isValidPhoneNumber(input.value) ? undefined : <p className="alert alert-danger">Invalid phone number</p>) : '' }
  </InputGroup>
);

const renderNoteField = ({ input, label, type, placeholder, meta: { active, touched, error, warning } }) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <FormControl
      {...input}
      componentClass="textarea"
      name="note"
      placeholder={placeholder}
    />
  </FormGroup>
);
// handleBrandChange(brands) {
//   const brandIds = brands.map(brand => brand.value);
//   this.setState({
//     brands: brandIds,
//     save: true,
//   });
// }

const RenderSelectInput = ({ input, options, name, id, label, help, meta: { active, touched, error, warning } }) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={(value) => {
        input.onChange(value.value);
      }}
      onBlur={(value) => input.onBlur(value.value)}
    />
    {(help && <HelpBlock>{help}</HelpBlock>)}
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);
// <div className="col-md-6">
//   <h4>{hotel.name}</h4>
//   <h4>{hotel.address}</h4>
//   <h4>{hotel.locality}, {hotel.region}, {hotel.postcode}</h4>
//   <h4>{hotel.tel}</h4>
//   <h4>{hotel.website}</h4>
// </div>


const PropertyOverviewForm = ({ onSubmit, initialValues, options, handleClose, brands }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={(values) => {
      const errors = {};
     // if (values.name!=undefined && !(values.name.trim())) {
      if (!(values.name)) {
        errors.FORM_ERROR = 'Hotel name must not be blank.';
      }
      if (!(values.address)) {
        errors.FORM_ERROR = 'Hotel address must not be blank.';
      }
      if (!(values.locality)) {
        errors.FORM_ERROR = 'Hotel city must not be blank.';
      }
      if (!(values.region)) {
        errors.FORM_ERROR = 'Hotel state must not be blank.';
      }
      if (!(values.postcode)) {
        errors.FORM_ERROR = 'Hotel postcode must not be blank.';
      }
      if (!(values.tel)) {
        errors.FORM_ERROR = 'Hotel contact must not be blank.';
      }
      if (!isValidPhoneNumber(values.tel)) {
        errors.CONTACT_ERROR = 'Please enter valid contact number.';
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit} >
        <div className="col-md-12">
          <div className="col-md-6">
            <FormGroup>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="address"
                component={renderTextField}
                label="Address"
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="locality"
                component={renderTextField}
                label="City"
              />
              {/* <Field
                name="region"
                component={renderTextField}
                label="State"
              /> */}
            </FormGroup>
            <FormGroup>
             <Field
                name="tel"
                type="text"
                country="US"
                component={customPhoneInput}
                label="Contact (Please select a Country and provide Contact)"
                placeholder="Enter phone number"
                 />
            </FormGroup>
          </div>
          <div className="col-md-6">
            <FormGroup>
              <Field
                name="postcode"
                component={renderTextField}
                label="Postcode"
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="website"
                component={renderTextField}
                label="Website"
              />
              {/* <Field
                name="brand"
                type="text"
                component={RenderSelectInput}
                label="Parent hotel"
                options={brands}
              /> */}
            </FormGroup>
            <FormGroup>
              <Field
                name="region"
                component={renderTextField}
                label="State"
              />
            </FormGroup>
          </div>
          <div className="col-md-6">
            <div></div>
            {errors.FORM_ERROR !== "undefined" && errors.FORM_ERROR && (
              <p className="alert alert-danger">{errors.FORM_ERROR}</p>
            )}
            {errors.note !== "undefined" && errors.note && (
              <p className="alert alert-danger">{errors.note}</p>
            )}
          </div>


        </div>

        <div className="col-md-12">
          <FormGroup>
            <ButtonToolbar>
              <Button
                disabled={pristine || submitting}
                bsStyle="success"
                type="submit"
              >
                <i className="fa fa-envelope fa-lg" /> Save
              </Button>
              <Button
                disabled={submitting}
                bsStyle="success"
                onClick={handleClose}
              >
                <i className="fa fa-envelope fa-lg" /> Cancel
              </Button>
            </ButtonToolbar>
          </FormGroup>

        </div>
      </form>
    )}
  />
);

export default PropertyOverviewForm;


// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyOverviewForm.js